import * as React from "react";
import type { SVGProps } from "react";
const SvgSmileySad = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M9.12 9.12v-1a1 1 0 0 0-1 1zm.096 0h1a1 1 0 0 0-1-1zm5.664 0v-1a1 1 0 0 0-1 1zm.085 0h1a1 1 0 0 0-1-1zm-5.75.077v1a1 1 0 0 0 1-1zm-.095 0h-1a1 1 0 0 0 1 1zm5.845 0v1a1 1 0 0 0 1-1zm-.085 0h-1a1 1 0 0 0 1 1zM12 14.404v-1zm2.478 2.407a1 1 0 1 0 1.7-1.053l-.85.527zm-6.656-1.053a1 1 0 1 0 1.7 1.053l-.85-.526zM21.6 12h-1a8.6 8.6 0 0 1-8.6 8.6v2c5.854 0 10.6-4.746 10.6-10.6zM12 21.6v-1A8.6 8.6 0 0 1 3.4 12h-2c0 5.854 4.746 10.6 10.6 10.6zM2.4 12h1A8.6 8.6 0 0 1 12 3.4v-2C6.146 1.4 1.4 6.146 1.4 12zM12 2.4v1a8.6 8.6 0 0 1 8.6 8.6h2c0-5.854-4.746-10.6-10.6-10.6zM9.12 9.12v1h.096v-2H9.12zm5.76 0v1h.085v-2h-.085zm-5.664 0h-1v.077h2V9.12zm0 .077v-1H9.12v2h.096zm-.096 0h1V9.12h-2v.077zm5.845-.077h-1v.077h2V9.12zm0 .077v-1h-.085v2h.085zm-.085 0h1V9.12h-2v.077zM12 14.404v1c1.03 0 1.948.55 2.478 1.407l.85-.526.85-.527c-.87-1.405-2.41-2.354-4.178-2.354zm-3.328 1.88.85.527c.53-.857 1.448-1.407 2.478-1.407v-2c-1.769 0-3.309.95-4.178 2.354z"
    />
  </svg>
);
export default SvgSmileySad;
